'use strict'

import { apiInstance } from './index'
import { mapArgs } from 'utils/functions'

// 获取用户列表新旧参数转换
const convertParams = params => {
  const { page, size, profiles, companyIds, search, email } = params || {}
  // 巴西手机号校验
  const phoneNumberRegex = /^\(?\d{2}\)?\s?\d\s?\d{4}-?\d{4}$/
  const searchIsPhoneNumber = phoneNumberRegex.test(search)

  const newParams = {
    page_no: page || 1,
    page_size: size || 25,
    profiles,
    company_id: companyIds,
    email,
    phone_number: searchIsPhoneNumber ? search.replace(/\D/g, '') : null,
    ekename: !searchIsPhoneNumber && !email && search ? search : null
  }

  return newParams
}
// 获取用户列表返回参数转换
const convertResponse = response => {
  const { data } = response || {}
  const { data: res } = data || {}
  const { tenant_user_list = [], page = {} } = res || {}

  const { total_page, total_count, size } = page || {}

  const list = tenant_user_list?.map(item => {
    const { pseudo_id, ekename, phone_number, profile, intention_contact_email } = item || {}
    return {
      corporateId: Number.isNaN(Number(pseudo_id)) ? null : Number(pseudo_id),
      id: pseudo_id,
      name: ekename,
      phone: phone_number,
      email: intention_contact_email,
      profile
    }
  })
  const temp = {
    valid: true,
    totalElements: total_count,
    totalPages: total_page,
    size: size,
    content: list || []
  }
  return {
    data: temp
  }
}

const users = {
  async get (...args) {
    const params = mapArgs(...args)

    const newParams = convertParams(params)
    const res = await apiInstance({
      method: 'GET',
      url: 'b2x-iam/v1/b2b/account/list',
      params: newParams
    })

    const newResponse = convertResponse(res)
    return newResponse
  },

  getById (id, params) {
    return apiInstance({
      method: 'GET',
      url: `b2b-iam-app/accounts/${id}`,
      params
    })
  },

  create (data, ...args) {
    const params = mapArgs(...args)
    return apiInstance({
      method: 'POST',
      url: `b2b-iam-app/accounts`,
      data,
      params
    })
  },

  update (id, data) {
    return apiInstance({
      method: 'PUT',
      url: `b2b-iam-app/accounts/${id}`,
      data
    })
  },

  delete (id) {
    return apiInstance({
      method: 'DELETE',
      url: `b2b-iam-app/accounts/${id}`
    })
  }
}

export default users
